import {DataObjectId} from 'yougile-model'
import {Sync} from '@client/sync'
import {Project} from '@extensions/project'
import {CbProps} from './types'

export const getBoards = (projectId?: DataObjectId): CbProps[] => {
  if (!projectId) {
    return []
  }

  const box = Sync.getCurrentSandbox()
  const project = box.get(projectId)

  return Project.listBoards(project, true)
}
